import { graphql } from 'react-relay';

/**
 * Added item to initial query to be able to pull
 * redirectPdp_item on server to determine if we need to redirect.
 * Do not add other framments to item in this query
 */

export const pdpRespRootQuery = graphql`
    query pdpRespRootQuery(
        $isClient: Boolean!
        $itemId: String!
        $itemIds: [String]!
        $userId: String = ""
        $userIds: [String]
        $fetchUser: Boolean!
        $relationshipUserIds: [String]!
        $followSearchPages: [String]
        $fetchFollowSearch: Boolean!
        $isTrade: Boolean!
        $isVip: Boolean!
        $isMultiSku: Boolean!
        $fetchPdp: Boolean!
        $forcedCurrency: Currency
        $fetchRegionalInfo: Boolean = false
        $userZipCode: String!
        $userCountryCode: String
    ) {
        viewer {
            ...PdpRespLayout_viewer
            ...getLanguageAnnotationsAndDomainLinksPdp_viewer
            itemRead(itemIds: $itemIds) {
                ... on Item {
                    ...redirectPdp_item
                }
                ...findPdpItemReadError_itemRead
            }
        }
    }
`;

export const pdpRespVariables = {
    isClient: false,
    itemId: null,
    itemIds: [],
    newAndCustomSplitTest: false,
    selectedItemIds: [],
    userId: '',
    userIds: [],
    fetchUser: false,
    loadPortfolioData: false,
    relationshipUserIds: [],
    followSearchPages: null,
    fetchFollowSearch: false,
    isTrade: false,
    isVip: false,
    isMultiSku: false,
    fetchPdp: true,
    forcedCurrency: null,
};
